import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHolidayList } from './firebase';
import { STATUS_IDLE, STATUS_FETCHING, STATUS_ERROR, STATUS_READY } from './constants';

export const fetchHolidays = createAsyncThunk('fetchHolidays', async () => await getHolidayList());

const HolidaySlice = createSlice({
  name: 'holidayList',
  initialState: {
    status: STATUS_IDLE,
    data: null,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchHolidays.pending, (state, action) => {
        state.status = STATUS_FETCHING;
      })
      .addCase(fetchHolidays.fulfilled, (state, action) => {
        state.status = STATUS_READY;
        state.data = action.payload;
      })
      .addCase(fetchHolidays.rejected, (state, action) => {
        state.status = STATUS_ERROR;
        state.error = action.error.message;
      });
  },
});

export default HolidaySlice.reducer;
